import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import AuthDialog from "@/components/AuthDialog";
import Home from "@/pages/Home";
import Favorites from "@/pages/Favorites";
import History from "@/pages/History";

function Shell() {
  const [authOpen, setAuthOpen] = useState(false);
  const { ready, user } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-linen">
        <div className="tape-label text-ink/40">CHARGEMENT…</div>
      </div>
    );
  }
  return (
    <div className="App min-h-screen bg-linen text-ink">
      <Header onOpenAuth={() => setAuthOpen(true)} />
      <Routes>
        <Route path="/" element={<Home onRequireAuth={() => setAuthOpen(true)} />} />
        <Route
          path="/favoris"
          element={user ? <Favorites /> : <Navigate to="/" replace />}
        />
        <Route
          path="/historique"
          element={user ? <History /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <AuthDialog open={authOpen} onClose={() => setAuthOpen(false)} />
      <footer className="border-t border-ink/10 mt-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 flex flex-wrap items-center justify-between gap-4">
          <div className="font-display font-black text-lg">
            SHOPSCOPE<span className="text-poppy">.</span>
          </div>
          <div className="tape-label text-ink/50">
            © {new Date().getFullYear()} — propulsé par GPT Vision
          </div>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              border: "1px solid #0A0A0A",
              borderRadius: 0,
              fontFamily: "Satoshi, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
